exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".voucher-add-item-left{width:25%}.voucher-add-des{padding:.25rem .75rem}.voucher-add-des .voucher-add-des-content{height:.8rem;line-height:.8rem}.voucher-add-bottom-tips{margin:0 .4rem}.voucher-add-footer{margin-top:.4rem}.my-ipt{font-size:.45rem!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1269e0ca","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/voucher/VoucherAdd.vue
// module id = 412
// module chunks = 0